<template>
  <div class="login buffer-top">
    <b-container>
      <b-row align-h="center">
        <b-col md="4">
          <b-alert
            v-model="showAlert"
            variant="danger"
            dismissible
          >{{ errorMsg }}
            <ul
              v-if="reasons && reasons.length"
              class="mt-2"
            >
              <li
                v-for="reason in reasons"
                :key="reason"
              >{{ reason }}</li>
            </ul>
          </b-alert>
          <h2>Login</h2>
          <b-form @submit.prevent="onLogin">
            <b-form-group>
              <b-form-input
                id="input-email"
                v-model="email"
                type="text"
                reqired
                placeholder="Benutzername"
              ></b-form-input>
            </b-form-group>
            <b-form-group>
              <b-form-input
                id="input-password"
                v-model="password"
                type="password"
                reqired
                placeholder="Passwort"
              ></b-form-input>
            </b-form-group>
            <b-button
              type="submit"
              variant="primary"
            >Login</b-button>
          </b-form>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>

import Auth from '../misc/Auth.js';
import { mapGetters } from 'vuex';

export default {
  name: 'Login',
  data: function () {
    return {
      email: '',
      password: '',
      errorMsg: '',
      showAlert: false,
      reasons: [],
    }
  },

  computed: {
    ...mapGetters(['prevTargetUrl', 'prevTargetHash'])
  },

  props: {
    redirect: String
  },

  methods: {
    onLogin: function () {
      Auth.login(this.email, this.password).then((response) => {
        console.log("Login successful", response);
        this.prevTargetUrl ? this.$router.push(this.prevTargetUrl) : this.$router.push('/admin/offer-list');
      }).catch(e => {
        this.showAlert = true;
        this.errorMsg = 'Anmeldung fehlgeschlagen';
        this.reasons = e.response.data.map(({ message }) => message);
        this.username = '';
        this.password = '';
      })
    }
  }
}

</script>
